module.exports = __webpack_public_path__ + "img/ballantines-age-confirm-bg.890d37e9.jpg";